import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/auth/AuthContext";
import Login from "./pages/Login";
import ProtectedRoute from "./routes/ProtectedRoute";
import PublicRoute from "./routes/PublicRoute";
import Modal from "react-modal";
import AuthenticatedLayout from "./general/components/layout/AuthenticatedLayout";

Modal.setAppElement("#root");

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route element={<PublicRoute />}>
            <Route path="/login" element={<Login />} />
          </Route>
          <Route element={<ProtectedRoute />}>
            {/* The layout hosts the robotics nav (sidebar) + active view. */}
            <Route path="/" element={<AuthenticatedLayout />} />
            {/* Legacy paths are now sidebar views inside the single shell. */}
            <Route path="/dashboard" element={<Navigate to="/" replace />} />
            <Route path="/maintenance" element={<Navigate to="/" replace />} />
            <Route path="/units" element={<Navigate to="/" replace />} />
          </Route>
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
